<template>
  <div class="academy-aticle aticle-container">
    <header class="aticle-hd">
      <div
        class="academy-hd-wrapper"
        v-scroll-animate="{
          animation: 'fadeInDown',
        }"
      >
        <h4 class="academy-hd-subTitle">狄诺尼学院</h4>
        <h2 class="academy-hd-title">快速掌握{{ productType }}，从这里开始</h2>
        <h4 class="academy-hd-subTitle">
          {{ productType }}进阶技巧，帮助你更进一步
        </h4>
        <h4 class="academy-hd-subTitle">技术支持：4000-025-828</h4>
      </div>
    </header>
    <div class="topTitle">
      <div class="flex-row">
        <div style="width: 80px">当前位置：</div>
        <div class="backBtn" @click="back('/academy')">
          狄诺尼学院&nbsp;> &nbsp;
        </div>
        <div
          v-if="$route.query.page"
          class="backBtn"
          @click="back('/academy/advancedTechniques')"
          style="max-width: 155px"
        >
          {{ productType }}进阶技巧&nbsp;> &nbsp;
        </div>
        <el-tooltip :content="article.title" placement="bottom-start">
          <div class="articleTitle">{{ article.title }}</div>
        </el-tooltip>
      </div>
    </div>

    <div class="aticle">
      <div class="title">{{ article.title }}</div>

      <div class="line"></div>

      <div class="date">发布时间：{{ article.date }}</div>

      <template v-if="article.type == 2">
        <div class="videoBox" v-if="article.videoUrl">
          <video controls :poster="article.coverPicUrl">
            <source :src="article.videoUrl" type="video/mp4" />
          </video>
        </div>
      </template>
      <template v-else>
        <div v-html="article.content" class="content"></div>
      </template>
    </div>
  </div>
</template>

<script>
import { newsDetailApi } from "@/api/website";
import { tracklogApi } from "@/api/website";
export default {
  name: "articleDetail",
  props: {},
  components: {},
  data() {
    return {
      article: {},
      productType: "AIRoad",
      articleId: "",
      categoryId: "",
      page: 1,
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.productType = this.$route.query.anchor || "";
    this.articleId = this.$route.query.id || "";
    this.categoryId = this.$route.query.categoryId || "";
    this.page = this.$route.query.page || 1;

    tracklogApi({ module: "3_" + this.articleId });
    this.getDetail();
  },
  methods: {
    back(url) {
      if (this.productType && this.categoryId) {
        if (url == "/academy") {
          this.$uniFun.openInCurrentTab(`${url}?&anchor=${this.productType}`);
        } else {
          this.$uniFun.openInCurrentTab(
            `${url}?&anchor=${this.productType}&categoryId=${this.categoryId}&page=${this.page}`,
          );
        }
      } else if (this.productType && !this.categoryId) {
        this.$uniFun.openInCurrentTab(`/academy?&anchor=${this.productType}`);
      } else {
        this.$uniFun.openInCurrentTab(`/academy`);
      }
    },
    getDetail() {
      let params = { id: this.articleId };
      newsDetailApi(params).then((res) => {
        if (res.code === 200 && res.success) {
          console.log("newsDetailApi", res);
          this.article = {
            title: res.data.title,
            type: res.data.type,
            date: res.data.effectiveTime.substring(0, 10),
            content: res.data.content,
            videoUrl:
              res.data.videoUrlIdList.length > 0
                ? res.data.videoUrlIdList[0].path
                : "",
            coverPicUrl:
              res.data.coverUrlIdList.length > 0
                ? res.data.coverUrlIdList[0].path
                : "",
          };
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/common.scss";
.academy-aticle.aticle-container {
  background: white;
  padding-bottom: 38px;
  .aticle-hd {
    width: 100%;
    height: 320px;
    background: url("~@/assets/images/academy/academy-hd_bg.png") no-repeat
      center;
    background-size: cover;
    .academy-hd-wrapper {
      width: 1049px;
      padding-top: 70px;
      margin: 0 auto;
    }
    .academy-hd-title {
      margin-bottom: 20px;
      font-weight: bold;
      font-size: 28px;
      color: #ffffff;
      line-height: 28px;
      font-style: normal;
    }
    .academy-hd-subTitle {
      margin-bottom: 20px;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      opacity: 0.8;
      line-height: 24px;
      font-style: normal;
    }
  }
  .topTitle {
    width: 100%;
    height: 64px;
    margin: 0 auto;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    text-align: left;
    border-bottom: 1px solid #d8d8d8;
    position: sticky;
    top: 80px;
    background: #fff;
    z-index: 20;
    > div {
      width: 1049px;
      margin: 0 auto;
      > div {
        height: 64px;
        line-height: 64px;
      }
      .articleTitle {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .backBtn {
    cursor: pointer;
    line-height: 64px;
  }
  .backBtn:hover {
    color: #0035fb;
    border-bottom: 2px solid #0035fb;
  }

  .aticle {
    margin: 38px auto 0;
    width: 1048px;
    background: #fbfbfb;
    padding: 29px 76px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    .title {
      font-weight: 600;
      font-size: 24px;
      color: #333333;
      line-height: 32px;
      text-align: center;
      font-style: normal;
    }
    .line {
      width: 100%;
      height: 1px;
      background: #dbdbdb;
    }

    .date {
      width: fit-content;
      height: 24px;
      font-weight: 400;
      font-size: 16px;
      color: #999999;
      line-height: 24px;
      text-align: center;
      font-style: normal;
      margin: 0 auto;
    }

    .content {
      margin-top: 24px;

      h2 {
        font-weight: bold;
        font-size: 16px;
        color: #666666;
        line-height: 32px;
        text-align: justify;
        font-style: normal;
      }

      p {
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 1.5;
        text-align: justify;
        margin: 15px 0px;
      }

      figcaption {
        font-weight: 400;
        font-size: 32px;
        color: #666666;
        line-height: 1.5;
        text-align: center;
      }
      img {
        max-width: 100%;
      }
      ul,
      ol {
        list-style: disc outside !important; /* ul 默认圆点 */
        padding-left: 2em;
        margin: 0.8em 0;
      }

      ol {
        list-style: decimal outside !important; /* ol 默认数字 */
      }

      li {
        display: list-item !important;
        list-style: inherit !important;
        margin: 0.5em 0;
      }
    }
    .videoBox {
      width: 100%;
      height: 590px;
      padding: 10px;
      box-sizing: border-box;
      background: #e4e7ed;
      border-radius: 8px;
      border: 1px solid #f8f8f8;
      video {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
